import React from "react";
import { Link } from "react-router-dom";
import { Prettify } from "../../utils/types";
import { BaseButton } from "./BaseButton";
import { BaseButtonProps, ButtonVariant, ButtonVariantProps } from "./types";

export type InternalLinkButtonProps = Prettify<Omit<BaseButtonProps<typeof Link>, "as" | "variant" | "disabled">> & {
    /**
     * Defines button variant.
     * @default "tertiary"
     */
    variant?: ButtonVariant;
} & ButtonVariantProps;

export const InternalLinkButton = React.forwardRef<HTMLAnchorElement, InternalLinkButtonProps>(
    ({ variant = "tertiary", ...props }, ref) => <BaseButton {...props} as={Link} variant={variant} ref={ref} />
);
